<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <!-- <Input  ></Input> -->
        <sl-area v-model="params.districtCode" placeholder="省市区"></sl-area>
        </Col>
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.companyName" placeholder="请输入企业名称" clearable ></Input>
        </Col>
        <Col span="6" :lg="6" :md="6" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.brandName" placeholder="请输入企业品牌" clearable ></Input>
        </Col>
        <Col span="6" :lg="6" :md="6" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        </Col>
      </Row>
    </div>
    <pie ref="pie" />
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <detail ref="item" @on-update="handleUpdate" />
  </sl-page>
</template>
<script>
import detail from './detail'
import pie from './pie'
import person from './person'

export default {
  components: { detail, pie, person },
  data() {
    return {
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '企业信息',
          minWidth: 250,
          render: (h, params) => {
            let row = params.row

            return h(person, {
              props: {
                row: row
              },
            })
          }
        },
        {
          title: '车辆总数',
          key: 'carNum',
          minWidth: 160,
        },
        {
          title: '未更新',
          key: 'waitUpdateNum',
          minWidth: 120,
        },
        {
          title: '待审核',
          key: 'waitCheckNum',
          minWidth: 120,
        },
        {
          title: '已更新',
          key: 'alreadyNum',
          minWidth: 120,
        },
        {
          title: '未通过',
          key: 'noPassNum',
          minWidth: 120,
        },
        // 已更新车辆数/车辆总数
        {
          title: '更新率(%)',
          minWidth: 120,
          render: (h, params) => {
            let row = params.row
            let rate = 0
            if (row.carNum) {
              rate = (row.alreadyNum*100 / row.carNum).toFixed(2)
            } else {
              rate = 0
            }
            if (!row.alreadyNum) {
              rate = 0
            }
            return h('div', rate)
          }
        },
        {
          title: '车辆更新时间',
          key: 'action',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            if(this.$a('car.updateRate.query')){
              return h('div', [
                h('a', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.detail(params.row)
                    }
                  }
                }, '查看')
              ])
            }
          }
        }
      ],
      data: [],
      params: {
        districtCode: null,
        companyName: null,
        brandName: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {
    getSearch() {
      let search = {}
      for (let key in this.params) {
        let v = this.params[key]
        if (!(v === null || v === undefined || v === '')) {
          if (Array.isArray(v)) {
            if (v.length) {
              search[key] = v
            }
          } else {
            search[key] = v
          }
        }
      }
      return search
    },

    list() {
      let search = this.getSearch()
      this.chartPie(search)

      let params = { search: search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.carChangeSummaryQueryPage(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          let data = resp.data
          this.data = data ? (data.list || []) : []
          this.page.total = data ? (data.total || 0) : 0
        }
      })
    },
    chartPie(search) {
      this.loading = true
      this.$request.carChangeChart(search).then(resp => {
        this.loading = false
        if (!resp.code) {
          let obj = resp.data || {}
          let data = []
          data.push({ value: obj.noPassNum || 0, name: '未通过' })
          data.push({ value: obj.waitUpdateNum || 0, name: '未更新' })
          data.push({ value: obj.waitCheckNum || 0, name: '待审核' })
          data.push({ value: obj.alreadyNum || 0, name: '已更新' })
          
          this.setPie(data)
        }
      })
    },

    detail(row) {
      this.$refs['item'].init(row.companyId)
    },

    setPie(data) {
      this.$refs['pie'].setData(data)
    },


    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },
  }
}

</script>
